module.exports = __webpack_public_path__ + "files/fddd979efea55964023ac459e2346387.png";